export interface FollowCountsInterface {
  followCount?: number;
  followerCount?: number;
  isCurrentUserFollowing?: boolean;
  followId?: string;
}
